// extracted by mini-css-extract-plugin
export default {"form":"form_form__v9NsD","form2":"form_form2__SVLwN"};